<template>
  <div>
    <div v-if="visible" class="modal-overlay">
      <!-- 弹窗遮罩层 -->
      <div class="modal-overlay">
        <div class="modal-container">
          <!-- 弹窗头部 -->
          <div class="modal-header">
            <h2 class="modal-title">🌟 重要提示</h2>
          </div>

          <!-- 弹窗内容 -->
          <div class="modal-body">
            <div class="important-note">
              <strong>请仔细阅读以下事项，确保顺利完成学习：</strong>
            </div>

            <!-- 浏览器要求 -->
            <div class="section">
              <h3 class="section-title">
                <span class="icon">🖥️</span>
                浏览器要求
              </h3>
              <div class="section-content">
                推荐使用
                <strong>Chrome 或 Edge</strong> 浏览器，确保支持H5功能。
              </div>
            </div>

            <!-- 人脸验证设置 -->
            <div class="section">
              <h3 class="section-title">
                <span class="icon">📸</span>
                人脸识别验证
              </h3>
              <div class="section-content">
                学习前请确认摄像头正常运行，本人头像在拍摄范围内。
                <br />请使用近期照片报名，避免因照片差异导致人脸识别不通过
              </div>
            </div>

            <!-- 特别说明 -->
            <!-- <div class="special-note">
              <div class="section-content" style="font-size: 18px">
                <span class="warning-icon">⚠️</span>
                <strong>特别说明：</strong>本平台仅提供
                <strong>2025年</strong> 继续教育公需科目在线学习，往年学习请
                <a
                  href="http://218.206.180.151:18080/fwpt/xzsvsp/default.aspx"
                  target="_blank"
                  style="color: #667eea; text-decoration: none"
                  >点击前往</a
                >。
              </div>
            </div> -->
          </div>

          <!-- 弹窗底部 -->
          <div class="modal-footer">
            <button class="confirm-btn" @click="handleCancel">
              我已了解，开始学习
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: true, // 控制弹出层的可见性
    };
  },
  methods: {
    showModal() {
      this.visible = true; // 显示弹出层
    },
    handleOk() {
      console.log("用户确认了警告");
      this.visible = false; // 关闭弹出层
    },
    handleCancel() {
      console.log("用户取消了警告");
      this.visible = false; // 关闭弹出层
    },
  },
};
</script>

<style scoped>
li {
  margin-bottom: 10px;
}
/* 弹窗遮罩层 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* 弹窗主体 */
.modal-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  max-width: 800px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  border-radius: 10px;
  overflow-y: auto;
}

/* 弹窗头部 */
.modal-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px 24px;
}

.modal-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

/* 弹窗内容 */
.modal-body {
  padding: 12px 24px;
}

.important-note {
  background-color: #fff3cd;
  border-left: 4px solid #ffc107;
  padding: 16px;
  margin-bottom: 24px;
}

.section {
  margin-bottom: 20px;
}

.section-title {
  color: #333;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-content {
  color: #666;
  line-height: 1.6;
  font-size: 14px;
}

.highlight {
  color: #e53e3e;
  font-weight: 500;
}

.tip-list {
  margin: 8px 0;
  padding-left: 20px;
}

.tip-list li {
  margin-bottom: 8px;
}

/* 特别说明 */
.special-note {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 16px;
  margin: 20px 0;
}

.warning-icon {
  color: #dc3545;
  font-weight: bold;
}

/* 弹窗底部 */
.modal-footer {
  padding: 20px 24px;
  text-align: center;
  border-top: 1px solid #eee;
}

.confirm-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 12px 32px;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.confirm-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

/* 图标样式 */
.icon {
  font-size: 18px;
  width: 24px;
  text-align: center;
}

/* 滚动条样式 */
.modal-container::-webkit-scrollbar {
  width: 6px;
}

.modal-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.modal-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.modal-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .modal-container {
    width: 95%;
    margin: 20px;
  }

  .modal-header {
    padding: 16px 20px;
  }

  .modal-title {
    font-size: 18px;
  }

  .modal-body {
    padding: 20px;
  }
}
</style>
